import type { Fields } from '@local-types/general';
import type { AdGroup } from '@local-types/group';
import type { UseFormReturn } from 'react-hook-form';
import { fields } from '../formConfig';
import {
  filter,
  mustIncludePatchFields,
  mustIncludePostFields,
  transformToAdGroup,
} from '../utils';
import { useGetAllowedTargeting } from '@apis/allowedTargeting';
import { useGetAllBidStrategies } from '@apis/bidStrategy';
import { useGetBudgetPacingOptions } from '@apis/budgetPacingOptions';
import type { Campaign } from '@local-types/campaign';

export const useGroupSectionPrefetch = ({
  adGroup,
  campaign,
  form,
  isDisplay,
}: {
  adGroup: AdGroup;
  campaign: Campaign;
  form: UseFormReturn<Fields<typeof fields>>;
  isDisplay: boolean;
}) => {
  const { data: allowedTargeting } = useGetAllowedTargeting();
  const { data: bidStrategies } = useGetAllBidStrategies();
  const { data: budgetPacingOptions } = useGetBudgetPacingOptions();

  return {
    prepareRequestData: () => {
      const values = form.getValues();
      return transformToAdGroup(values, {
        bidStrategies,
        budgetPacingOptions,
        campaign,
        adGroup,
        allowedTargeting,
        isDisplay,
        filter: filter(
          adGroup.temporary ? mustIncludePostFields : mustIncludePatchFields
        ),
      });
    },
  };
};
